import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
import Emoji from "@/components/Emoji";
import { YearsCounter } from "@/components/Hero/YearsCounter";
import { Link } from "@/components/Link";
import Heading from "./ui/Heading";

// These tags are available
type Tag = "h1" | "h2" | "h3" | "h4" | "h5" | "p" | "br" | "em" | "b" | "strong" | "linkContact" | "linkKudos" | "emoji" | "yearsCounter";
type Props = {
  children(_tags: Record<Tag, (_chunks: ReactNode) => ReactNode>): ReactNode;
};
const tags = {
  h1: (chunks: ReactNode) => <Heading fx>{chunks}</Heading>,
  h2: (chunks: ReactNode) => <Heading level={2}>{chunks}</Heading>,
  h3: (chunks: ReactNode) => <Heading level={4} className="text-mint">
      {chunks}
    </Heading>,
  h4: (chunks: ReactNode) => <Heading level={5}>{chunks}</Heading>,
  h5: (chunks: ReactNode) => <Heading level={6} className="text-mint">
      {chunks}
    </Heading>,
  p: (chunks: ReactNode) => <p>{chunks}</p>,
  br: () => <br />,
  em: (chunks: ReactNode) => <em className="not-italic text-mint">{chunks}</em>,
  b: (chunks: ReactNode) => <b>{chunks}</b>,
  strong: (chunks: ReactNode) => <strong>{chunks}</strong>,
  linkContact: (chunks: ReactNode) => <Link href={"/contact"} className="underline-link text-mint">
      {chunks}
    </Link>,
  linkKudos: (chunks: ReactNode) => <Link href={"/kudos"} className="underline-link text-mint">
      {chunks}
    </Link>,
  emoji: (chunks: ReactNode) => {
    return <Emoji>{chunks}</Emoji>;
  },
  yearsCounter: () => <YearsCounter />
};
export default function RichText(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = children(tags);
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <>{t1}</>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}